import { render, staticRenderFns } from "./delDialog.vue?vue&type=template&id=d5a8ca8c&"
import script from "./delDialog.vue?vue&type=script&lang=js&"
export * from "./delDialog.vue?vue&type=script&lang=js&"
import style0 from "./delDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports